module.exports = __webpack_public_path__ + "dcb26c7239d850266941e80370e207c1.ttf";